
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import {Sticky} from 'react-sticky'
import DatePicker from 'components/DatePicker'
import Breadcrumbs from 'components/Breadcrumbs'
import classnames from 'classnames'
import {
  selectGlobalDateRange
} from 'redux/modules/currentUser/actions'
import {
  getCurrentTimePeriod,
  getSelectedDateRange
} from 'redux/modules/currentUser/selectors'
import {getLoadingAnalytics} from 'redux/modules/analytics/selectors'
import {getLoadingOrders} from 'redux/modules/orders/selectors'
import {getConversionFetching} from 'redux/modules/insights/selectors'
import moment from 'moment'

export class TopPanel extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    menu: PropTypes.node,
    breadcrumbs: PropTypes.array,
    startDate: PropTypes.instanceOf(Date),
    endDate: PropTypes.instanceOf(Date),
    timePeriod: PropTypes.string,
    dynamicDateType: PropTypes.string,
    today: PropTypes.instanceOf(Date),
    datePicker: PropTypes.bool,
    datePickerLoading: PropTypes.bool,
    selectGlobalDateRange: PropTypes.func
  }
  constructor(props) {
    super(props)
    this.state = {
      type: props.timePeriod
    }
  }
  render() {
    const {breadcrumbs} = this.props

    return (
      <div className='top-panel'>
        <div className='top-panel_header'>
          <Breadcrumbs items={breadcrumbs} />
          {this.renderTitle()}
        </div>
        {this.renderActions()}
      </div>
    )
  }

  renderActions() {
    const {menu} = this.props

    return (
      <Sticky>
        {({style, isSticky}) => {
          const classNames = classnames('top-panel_actions', {'is-sticky': isSticky})
          return (
            <div className={classNames} style={style}>
              {menu}
              {this.renderCalendar()}
            </div>
          )
        }}
      </Sticky>
    )
  }

  renderTitle() {
    const {title} = this.props

    if (title) {
      return <h1 className='top-panel_title'>{title}</h1>
    } else {
      return null
    }
  }

  renderCalendar() {
    const {
      datePicker,
      datePickerLoading,
      startDate,
      endDate,
      dynamicDateType,
      today,
      selectGlobalDateRange
    } = this.props
    if (!datePicker) return null
    const {type} = this.state

    return (
      <DatePicker
        className='top-panel_calendar'
        startDate={moment(startDate).clone().toDate()}
        endDate={moment(endDate).clone().toDate()}
        dynamicDateType={dynamicDateType}
        type={type}
        disabled={datePickerLoading}
        onChangeModes={this.onChangeModes}
        today={moment(today).clone().toDate()}
        onSelect={this.selectGlobalDateRange}
      />
    )
  }
  onChangeModes = type => {
    this.setState({
      type
    })
  }
  selectGlobalDateRange = (startDate, endDate, dynamicDateType = false, range) => {
    const {type} = this.state
    const {selectGlobalDateRange} = this.props
    selectGlobalDateRange(startDate, endDate, dynamicDateType, type)
  }
}

const mapStateToProps = (state, props) => {
  const {startDate, endDate, dynamicDateType} = getSelectedDateRange(state)
  const timePeriod = getCurrentTimePeriod(state)
  const {today} = state
  const loading = getLoadingAnalytics(state) || getLoadingOrders(state) || getConversionFetching(state)
  return {
    startDate,
    endDate,
    timePeriod,
    dynamicDateType,
    datePickerLoading: loading,
    today
  }
}

export default connect(mapStateToProps, {
  selectGlobalDateRange
})(TopPanel)



// WEBPACK FOOTER //
// ./client/containers/TopPanel/index.js